export const UPDATE_EMAIL_NOTIFICATION_REQUEST = "UPDATE_EMAIL_NOTIFICATION_REQUEST";
export const UPDATE_EMAIL_NOTIFICATION_SUCCESS = "UPDATE_EMAIL_NOTIFICATION_SUCCESS";
export const UPDATE_EMAIL_NOTIFICATION_FAILURE = "UPDATE_EMAIL_NOTIFICATION_FAILURE";
export const UPDATE_EMAIL_NOTIFICATION_RESET = "UPDATE_EMAIL_NOTIFICATION_RESET";
export const updateEmailNotificationDataRequest = (payload) => ({
    type: UPDATE_EMAIL_NOTIFICATION_REQUEST,
    payload,
});
export const updateEmailNotificationDataSuccess = (payload) => ({
    type: UPDATE_EMAIL_NOTIFICATION_SUCCESS,
    payload,
});
export const updateEmailNotificationDataFailure = (error) => ({
    type: UPDATE_EMAIL_NOTIFICATION_FAILURE,
    payload: error,
});
export const updateEmailNotificationDataReset = () => ({
    type: UPDATE_EMAIL_NOTIFICATION_RESET,
});
